import { render, staticRenderFns } from "./UserKonto.vue?vue&type=template&id=dba78e82&"
import script from "./UserKonto.vue?vue&type=script&lang=js&"
export * from "./UserKonto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports